import { render, staticRenderFns } from "./AtomContact.vue?vue&type=template&id=3252fd94&"
import script from "./AtomContact.vue?vue&type=script&lang=js&"
export * from "./AtomContact.vue?vue&type=script&lang=js&"
import style0 from "./AtomContact.vue?vue&type=style&index=0&id=3252fd94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports